import Icon from '../components/Icon.vue'

Icon.register({
  'user-friends': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M192 256C253.9 256 304 205.9 304 144S253.9 32 192 32 80 82.1 80 144 130.1 256 192 256zM268.8 288H260.5C239.7 298 216.6 304 192 304S144.4 298 123.5 288H115.2C51.6 288 0 339.6 0 403.2V432C0 458.5 21.5 480 48 480H336C362.5 480 384 458.5 384 432V403.2C384 339.6 332.4 288 268.8 288zM480 256C533 256 576 213 576 160S533 64 480 64 384 107 384 160 427 256 480 256zM528 288H524.2C510.3 292.8 495.6 296 480 296S449.7 292.8 435.8 288H432C411.6 288 392.8 293.9 376.3 303.4 400.7 329.7 416 364.6 416 403.2V441.6C416 443.8 415.5 445.9 415.4 448H592C618.5 448 640 426.5 640 400 640 338.1 589.9 288 528 288z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-friends.js
// module id = P0rL
// module chunks = 144